<sdx-header [attr.navigation]="navigation" [attr.login]="login" [attr.index]="index"> </sdx-header>
